export const environment = {
    production: false,
    apiBaseUrl: 'https://apidomiciliario.dllosura.com',
    programadorBaseUrl: 'https://programador-domiciliario.dllosura.com',
    portBaseUrl: '',
    seusBaseUrl: 'https://domiciliario.dllosura.com/',
    geoSuraBaseUrl: 'https://geolab.sura.com',
    hada: {
        idComponent: 'web-component',
        env: 'labo',
        appsource: 'plataformaDomiciliaria',
        url: 'https://autotriajelab.epssura.com/static/js/wc-hada.js',
        initialroute: 'ODONTOLOGYHOME'
    },
    backend: {
        fire: {
            connection: {
                projectId: 'atenciondomiciliaria-dll',
                appId: '1:848071905141:web:41ca293cdcf5b38a2f0d3c',
                storageBucket: 'atenciondomiciliaria-dll.firebasestorage.app',
                apiKey: 'AIzaSyC6rvC7VR1_VB0u_vnWatjO9uIo-HpL5Vg',
                authDomain: 'atenciondomiciliaria-dll.firebaseapp.com',
                messagingSenderId: '848071905141',
                measurementId: 'G-TXGVY0H5F4'
            },
            emulate: false
        }
    }
};
